import React from "react";
import "./Our_team.css";
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";

function Our_team() {
    const founder = {
        name: "Mr. Sunil Palekar",
        role: "CEO",
        description:
            "Authorised service provider for Cassida (USA). Expert in Coin Counter & Sorting Machines with pan India service coverage.",
        image: "/assets/images/about_us/our_team/sunil_palekar.png",
    };

    const teamMembers = [
        {
            id: 1,
            name: "Mr. Shrikant Bhosle",
            role: "General Manager",
            description:
                "Oversees client relations and nationwide operations for automation services.",
            image: "/assets/images/about_us/our_team/Shrikant_Bhosle.png",
        },
        {
            id: 2,
            name: "Mr. Akshay Dipil Dhotre",
            role: "Marketing Head",
            description:
                "Leads marketing initiatives and manages client engagement across India.",
            image: "/assets/images/about_us/our_team/akshay.png",
        },
    ];

    const freelancers = [
        {
            id: 1,
            name: "Mr. Vishal Gaikwad",
            role: "CEO, Vishal Automation",
            description:
                "Authorised service provider for Cassida (USA). Expert in Coin Counter & Sorting Machines with pan India service coverage.",
            image: "/assets/images/about_us/our_team/vishal.png",
        },
        {
            id: 2,
            name: "Mr. Ravindra Kutal",
            role: "Freelance Marketing Consultant",
            description:
                "20 years of experience providing currency counting machine services across Maharashtra, supported by Scroma Venture.",
            image: "/assets/images/about_us/our_team/Ravindra_Kutal.png",
        },
    ];

    return (
        <section className="Our_team section_margin">
            <Container>
                <h2 className="title">Our Team</h2>

                {/* Tabs Section */}
                <Tabs
                    defaultActiveKey="founder"
                    id="our-team-tabs"
                    className="justify-content-center mb-5"
                    fill
                >
                    {/* Founder Tab */}
                    <Tab eventKey="founder" title="Founder">
                        <div className="Our_team_founder text-center mt-4">
                            <div className="Our_team_founder_card">
                                <div className="Our_team_founder_img_holder">
                                    <img
                                        src={founder.image}
                                        alt={founder.name}
                                        className="Our_team_founder_img"
                                    />
                                </div>
                                <div className="Our_team_founder_info">
                                    <h4 className="Our_team_founder_name">{founder.name}</h4>
                                    <p className="Our_team_founder_role">{founder.role}</p>
                                    <p className="Our_team_founder_description">
                                        {founder.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Tab>

                    {/* Team Members Tab */}
                    <Tab eventKey="team" title="Team Members">
                        <div className="Our_team_members mt-4">
                            <Row className="gy-4 justify-content-center">
                                {teamMembers.map((member) => (
                                    <Col key={member.id} xl={4} md={6} sm={6} xs={12}>
                                        <div className="Our_team_card">
                                            <div className="Our_team_img_holder">
                                                <img
                                                    src={member.image}
                                                    alt={member.name}
                                                    className="Our_team_img"
                                                />
                                            </div>
                                            <div className="Our_team_info_holder">
                                                <h5 className="Our_team_name">{member.name}</h5>
                                                <p className="Our_team_role">{member.role}</p>
                                                <p className="Our_team_description">
                                                    {member.description}
                                                </p>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Tab>

                    {/* Core Team Tab */}
                    <Tab eventKey="freelancers" title="Core Team">
                        <div className="Our_team_freelancers mt-4">
                            <Row className="gy-4 justify-content-center">
                                {freelancers.map((member) => (
                                    <Col key={member.id} xl={4} md={6} sm={6} xs={12}>
                                        <div className="Our_team_card freelancer">
                                            <div className="Our_team_img_holder">
                                                <img
                                                    src={member.image}
                                                    alt={member.name}
                                                    className="Our_team_img"
                                                />
                                            </div>
                                            <div className="Our_team_info_holder">
                                                <h5 className="Our_team_name">{member.name}</h5>
                                                <p className="Our_team_role">{member.role}</p>
                                                <p className="Our_team_description">
                                                    {member.description}
                                                </p>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Tab>
                </Tabs>
            </Container>
        </section>
    );
}

export default Our_team;
